export const titleUpdater = (newTitle) => {
    return document.title = newTitle;
}